export enum PlanType {
  SLAB = 'SLAB',
  WALL = 'WALL',
}
